import * as api from './api';

 export async function getCdi() {
    let retorno = await api.get('cdi/percentage');
    return retorno;
}